import React from 'react';
import Banner from "../../../components/pages/grid/Banner/Banner";

const BannerGridPage = () => {
    return <Banner />
};

export default BannerGridPage;